import { render } from "./NotificationModal.vue?vue&type=template&id=d7ea4da2&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=d7ea4da2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ea4da2"]])

export default __exports__